<template>
  <CModal
    class="modal__footer-empty"
    size="lg"
    :close-on-backdrop="false"
    :show="show"
    @update:show="closeModal"
  >
    <template #header>
      <div class="d-flex align-items-center">
        <span class="title">{{ title }}</span>
      </div>

      <CButtonClose @click="closeModal"/>
    </template>

    <div class="subflow">
      <VCarForm
        :car="selectedCar"
        :show="show"
      />
    </div>
  </CModal>
</template>
<script>
import VCarForm from "@/components/Forms/VCarForm";
import { modalStore } from "@/mixins/modalsMixin";

export default {
  name: "TheEditCarModal",

  components: {
    VCarForm
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    title() {
      return this.selectedCar.title
    },
    selectedCar() {
      return this.$store.getters[`${modalStore.moduleName}/${modalStore.getterTypes.GETTER_MODAL_CONTENTS}`] || {};
    },
  },

  methods: {
    closeModal() {
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        )
      }, 500)
      this.$emit("close");
    },

    onSuccess() {
      this.closeModal();
    }
  }
};
</script>
<style>
.title {
  font-weight: 700;
  font-size: 22px;
  line-height: 22px;
}
</style>